import React from 'react';
import styled from 'styled-components';
import {CatalogItemCard} from '../../../common/ui/CatalogItemCard';
import {PriceWithFallback} from '../../../common/ui/PriceWithFallback';
import {Indicador} from '../../../ui';
import {usePendingOrders} from '../../../product/application/usePendingOrders';
import {AddRestockedToCartButton} from '../../../product/ui/AddRestockedToCartButton';
import {isSuccess} from '../../../common/domain/RemoteData.model';

const Container = styled.div`
    display: flex;
    gap: 1.5rem;
    flex-direction: column;
`;

const GridWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    box-sizing: border-box;
`;

const CardWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

/**
 * Sección destacada de la home con los pedidos pendientes que ya tienen stock.
 */
export const RestockedPendingProducts = () => {
    const {pendingData, restocked, refresh, removeLocally} = usePendingOrders();

    if (!isSuccess(pendingData) || restocked.length === 0) {
        return null;
    }

    return (
        <Container>
            <Indicador indicador="¡Ya hay stock de tus pendientes!" />
            <GridWrapper>
                {restocked.map((pendingOrder) => (
                    <CardWrapper key={pendingOrder.product.code}>
                        <CatalogItemCard data={{ catalogItem: pendingOrder.product }}>
                            <CatalogItemCard.Price>
                                <PriceWithFallback data={{
                                    sellingPrice: pendingOrder.product.price?.bestPrice,
                                    basePrice: pendingOrder.product.price?.value
                                }}/>
                            </CatalogItemCard.Price>
                        </CatalogItemCard>
                        <AddRestockedToCartButton
                            pendingOrder={pendingOrder}
                            onAdded={removeLocally}
                            onFailed={refresh}
                        />
                    </CardWrapper>
                ))}
            </GridWrapper>
        </Container>
    );
};
